function objectType(obj) {
  return Object.prototype.toString.call(obj).slice(8, -1)
}

function removeCookie(cookie) {
  const cookieDomain = cookie.domain ? cookie.domain : window.CConsentManager.config.rootDomain
  // Removing cookies from domain and .domain
  const domain = objectType(cookieDomain) === 'String' ? `domain=${cookieDomain};` : ''
  document.cookie = `${
    cookie.cookieName
  }=; expires=Thu, 01 Jan 1980 00:00:00 UTC; ${domain} path=/;`
}

export function removeCookies() {
  const currentCookiesList = []
  const { config } = window.CConsentManager

  document.cookie.split(';').forEach((cookie) => {
    const cookieName = cookie.split('=')[0].replace(/(^\s*)|(\s*&)/, '')
    currentCookiesList.push(cookieName)
  })

  function checkTypeAndRemoveCookie({ type, cookieNameToRemove, service }) {
    if (type === 'String') {
      if (currentCookiesList.includes(cookieNameToRemove)) {
        removeCookie({ cookieName: cookieNameToRemove, domain: service.domain })
      }
    } else if (type === 'RegExp') {
      // Searching cookie list for cookies matching specified RegExp
      currentCookiesList.forEach((cookieName) => {
        if (cookieName.match(cookieNameToRemove)) {
          removeCookie({
            cookieName,
            domain:
              objectType(service.domain) === 'String'
                ? service.domain
                : null
          })
        }
      })
    }
  }

  const nonMandatoryCategories = config.categories.filter((category) => !category.mandatory)
  nonMandatoryCategories.forEach((category) => {
    if (Array.isArray(category.services)) {
      // Remove cookies if they are not wanted by user
      category.services.forEach((service) => {
        if (!service.wanted) {
          let type = objectType(service.cookieName)
          if (Array.isArray(service.cookieName)) {
            service.cookieName.forEach((cookieNameToRemove) => 
              checkTypeAndRemoveCookie({ type: objectType(cookieNameToRemove), cookieNameToRemove, service }))
          } else {
            checkTypeAndRemoveCookie({ type, cookieNameToRemove: service.cookieName, service })
          }
        }
      })
    }
  })
}
